'use client'

import { ButtonPrimary } from 'fukku/Button/Primary'
import { useLabels } from 'labels/hooks/useLabels/useLabels'

import { useColors } from '../../contexts/ColorsProvider/ColorsProvider'
import { useSizes } from '../../contexts/SizesProvider/SizesProvider'

import styles from './BackInStockButton.module.scss'

export function BackInStockButtonLegacy(): React.ReactNode {
	const { t } = useLabels()
	const { selectedColor } = useColors()
	const { openSheet } = useSizes()

	const shouldShowBackInStock =
		!selectedColor.isSellable && !selectedColor.isUniqueSize

	return (
		shouldShowBackInStock && (
			<ButtonPrimary
				className={styles.backInStockButton}
				onClick={() => openSheet(true)}
			>
				{t('notifyMe.pdp.button')}
			</ButtonPrimary>
		)
	)
}
